"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVocoUpload = void 0;
var _react = require("react");
var _utils = require("../utils");
var _iocModules = require("../ioc/iocModules");
const useVocoUpload = _ref => {
  let {
    url,
    schemeId,
    uploaded,
    handleUploadError,
    dimensions,
    mode,
    format
  } = _ref;
  const [accept, setAccept] = (0, _react.useState)('');
  const [isUploading, setIsUploading] = (0, _react.useState)(false);
  const [validationMessage, setValidationMessage] = (0, _react.useState)('');
  const uploadUrl = (0, _react.useMemo)(() => {
    const apiPort = 3001;
    const apiUploadPath = 'upload';
    return url || (0, _iocModules.getApiAddress)({
      port: apiPort,
      path: apiUploadPath
    });
  }, [url]);
  const uploadFile = (0, _react.useCallback)(fileObj => {
    const formData = new FormData();
    formData.append('file', fileObj);
    formData.append('schemeId', schemeId);
    setIsUploading(true);
    (0, _utils.request)(uploadUrl, {
      method: 'POST',
      body: formData
    }).then(res => {
      uploaded({
        filename: res
      });
    }).catch(err => {
      if (handleUploadError) {
        return handleUploadError(err);
      }
      _utils.logger.error('upload ERROR', err);
    }).then(() => setIsUploading(false));
  }, [schemeId, uploadUrl, uploaded, handleUploadError]);
  const upload = (0, _react.useCallback)(file => {
    setValidationMessage('');
    if (dimensions) {
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      img.onload = function () {
        const imgWidth = this.width;
        const imgHeight = this.height;
        if (dimensions.min[0] <= imgWidth && dimensions.max[0] >= imgWidth && dimensions.min[1] <= imgHeight && dimensions.max[1] >= imgHeight) {
          uploadFile(file);
        } else {
          setValidationMessage('Image does not satisfy dimension limits.');
        }
      };
      img.src = _URL.createObjectURL(file);
    } else {
      uploadFile(file);
    }
  }, [dimensions, uploadFile]);
  (0, _react.useEffect)(() => {
    if (!format) {
      switch (mode) {
        case 'gallery':
          setAccept('.jpg,.png,.csv');
          break;
        default:
          setAccept('.jpg,.png,.csv');
          break;
      }
    } else {
      setAccept(format.join(','));
    }
  }, [format, mode]);
  return {
    accept,
    isUploading,
    validationMessage,
    upload
  };
};
exports.useVocoUpload = useVocoUpload;